export default class PersonModel {
  constructor (data) {
    this.relationships = []
    this.logentries = []

    this.values = {
      id: null,
      image: null,
      lastname: null,
      suffix: null,
      maidenname: null,
      maidensuffix: null,
      initials: null,
      forenames: null,
      nickname: null,
      gender: null,
      address: null,
      zipcode: null,
      city: null,
      country: null,
      phone: null,
      mobile: null,
      email: null,
      dateofbirth: null,
      dateofdeath: null,
      sendbirthdaycard: null,
      sendbirthdayemail: null,
      countryoforigin: null,
      linkedinid: null,
      twitterid: null,
      facebookid: null,
      skypeid: null,
      religion: null,
      maritalstatus: null,
      sendchristmasemail: null,
      sendchristmascard: null,
      region: null,
      nationality: null
    }

    window.PRIM.modelMapper.mapToModel(data, this.values)
  }

  getTitle () {
    let title = []

    if (this.values.nickname) {
      title.push(this.values.nickname)
    }

    if (this.values.suffix) {
      title.push(this.values.suffix)
    }

    if (this.values.lastname) {
      title.push(this.values.lastname)
    }

    return title.join(' ')
  }
  getSubtitle () {
    return [this.values.city].join(' ')
  }
  getImage () {
    return this.values.image
  }
  getIndex () {
    if (this.getCompareString()) {
      return this.getCompareString().substring(0, 1).toUpperCase()
    }

    return null
  }
  getCompareString () {
    let title = []

    if (this.values.lastname) {
      title.push(this.values.lastname)
    }

    if (this.values.suffix) {
      title.push(this.values.suffix)
    }

    if (this.values.nickname) {
      title.push(this.values.nickname)
    }

    if (this.values.city) {
      title.push(this.values.city)
    }

    return title.join(' ')
  }

  getJSON () {
    let result = {}

    window.PRIM.modelMapper.mapToObject(this.values, result)

    return result
  }
}



// WEBPACK FOOTER //
// ./js/modules/person/model/PersonModel.js